import React from 'react'

const Certificates = () => {
  return (
    <div>
      
    </div>
  )
}

export default Certificates
